<template>
  <div class="m-15">
    <b-row>
      <b-col xl="4" lg="4" md="6" sm="12">
        <picture-input
          ref="pictureInput0"
          :zIndex="10"
          :crop="false"
          :removable="true"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: '1<br>Clique aqui para <br> selecionar uma imagem',
                    drag: '1<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
          @change="onChange(0)"
          @remove="onRemove(0)"
        ></picture-input>
      </b-col>
      <b-col xl="4" lg="4" md="6" sm="12" class="sm-mt-3">
        <picture-input
          ref="pictureInput1"
          :zIndex="10"
          :crop="false"
          :removable="true"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: '2<br>Clique aqui para <br> selecionar uma imagem',
                    drag: '2<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
          @change="onChange(1)"
          @remove="onRemove(1)"
        ></picture-input>
      </b-col>
      <b-col xl="4" lg="4" md="6" sm="12" class="md-mt-3">
        <picture-input
          ref="pictureInput2"
          :zIndex="10"
          :crop="false"
          :removable="true"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: '3<br>Clique aqui para <br> selecionar uma imagem',
                    drag: '3<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
          @change="onChange(2)"
          @remove="onRemove(2)"
        ></picture-input>
      </b-col>
      <b-col xl="4" lg="4" md="6" sm="12" class="mt-3">
        <picture-input
          ref="pictureInput3"
          :zIndex="10"
          :crop="false"
          :removable="true"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: '4<br>Clique aqui para <br> selecionar uma imagem',
                    drag: '4<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
          @change="onChange(3)"
          @remove="onRemove(3)"
        ></picture-input>
      </b-col>
      <b-col xl="4" lg="4" md="6" sm="12" class="mt-3">
        <picture-input
          ref="pictureInput4"
          :zIndex="10"
          :crop="false"
          :removable="true"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: '5<br>Clique aqui para <br> selecionar uma imagem',
                    drag: '5<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
          @change="onChange(4)"
          @remove="onRemove(4)"
        ></picture-input>
      </b-col>
      <b-col xl="4" lg="4" md="6" sm="12" class="mt-3">
        <picture-input
          ref="pictureInput5"
          :zIndex="10"
          :crop="false"
          :removable="true"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: '6<br>Clique aqui para <br> selecionar uma imagem',
                    drag: '6<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
          @change="onChange(5)"
          @remove="onRemove(5)"
        ></picture-input>
      </b-col>
      <b-col xl="4" lg="4" md="6" sm="12" class="mt-3">
        <picture-input
          ref="pictureInput6"
          :zIndex="10"
          :crop="false"
          :removable="true"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: '7<br>Clique aqui para <br> selecionar uma imagem',
                    drag: '7<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
          @change="onChange(6)"
          @remove="onRemove(6)"
        ></picture-input>
      </b-col>
      <b-col xl="4" lg="4" md="6" sm="12" class="mt-3">
        <picture-input
          ref="pictureInput7"
          :zIndex="10"
          :crop="false"
          :removable="true"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: '8<br>Clique aqui para <br> selecionar uma imagem',
                    drag: '8<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
          @change="onChange(7)"
          @remove="onRemove(7)"
        ></picture-input>
      </b-col>
      <b-col xl="4" lg="4" md="6" sm="12" class="mt-3">
        <picture-input
          ref="pictureInput8"
          :zIndex="10"
          :crop="false"
          :removable="true"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: '9<br>Clique aqui para <br> selecionar uma imagem',
                    drag: '9<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
          @change="onChange(8)"
          @remove="onRemove(8)"
        ></picture-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import axios from "axios";

export default {
  name: "imagemjornalzinho",
  components: {
    PictureInput
  },
  data: () => {
    return {
      id: "",
      selecionado: 2
    };
  },
  methods: {
    onChange(index) {
      var arr = Object.values(this.$refs);
      var image = arr[index].image;
      localStorage.setItem(`image-${index + 1}`, image);
      if (index == 0) {
        if (image) this.$emit("can-continue", { value: true });
        else this.$emit("can-continue", { value: false });
      }
    },
    onRemove(index) {
      localStorage.removeItem(`image-${index + 1}`);
      if (index == 0) {
        this.$emit("can-continue", { value: false });
      }
    },
    removeImagens() {
      for (let i = 1; i < 10; i++) {
        localStorage.removeItem(`image-${i}`);
      }
    }
  },
  beforeMount() {
    this.removeImagens();
  }
};
</script>
